// const BASE_URL = "http://localhost:4000/api/v1"

// anildhyani

const BASE_URL = "https://anil-dhyani-backend-rho.vercel.app/api/v1"


export const blogEndpoints = {
    CREATE_BLOG : BASE_URL + "/blog/createblog",
    GET_ALL_BLOG : BASE_URL + "/blog/getallblog",

    UPLOAD_IMAGE : BASE_URL + "/blog/upload-image",
    DELETE_BLOG_BY_ID : (id) => BASE_URL + `/blog/deleteblogbyid/${id}`,
    GET_BLOG_BY_ID : (id) => BASE_URL + `/blog/getblogbyid/${id}`,



}

export const contactEndpoints = {
    CONTACT : BASE_URL + "/contact/contact-us",
    



}

export const adminEndpoints = {
    LOGIN_API_FOR_ADMIN : BASE_URL + "/auth/login",
    API_FOR_LOGIN : BASE_URL + "/auth/login"
    
}

export const careerEndpoints = {
    INTERNSHIP_API : BASE_URL + "/internship/apply-internship",
    RETRAINERSHIP_API : BASE_URL + "/retainership/apply-retainership",
    
}